import { motion } from "framer-motion";
import { Medal, Gauge, Fire, FirstAid, Wrench, Devices, ShieldCheckered, Cpu, Airplane, ClipboardText } from "@phosphor-icons/react";
import { useLang } from "../../context/LangContext";

const reveal = {
  hidden: { opacity: 0, y: 28 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: (i % 4) * 0.08, ease: [0.16, 1, 0.3, 1] } }),
};

const ICONS = [Medal, Gauge, Fire, FirstAid, Wrench, Devices, ShieldCheckered, Cpu, Airplane, ClipboardText];
const IMAGES = ["iso9001", "ped", "atex", "mdr", "manutenzione", "consumer", "cybersecurity", "automazione", "aerospace", "consulenza"];

export const ComplianceSectors = () => {
  const { t } = useLang();
  const s = t.sectors;

  return (
    <section id="sectors" className="bg-[#F8F9FA] py-24 lg:py-32" data-testid="compliance-sectors">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div className="max-w-2xl">
          <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="font-mono-tech text-xs uppercase tracking-[0.2em] font-semibold text-emerald-600">
            [ {s.overline} ]
          </motion.p>
          <motion.h2 initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-80px" }} variants={reveal} className="mt-4 font-display font-bold text-4xl sm:text-5xl tracking-tight text-[#0F172A]">
            {s.title}
          </motion.h2>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {s.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div key={item.tag} custom={i} variants={reveal} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-60px" }}
                className="group relative overflow-hidden rounded-md min-h-[340px] flex flex-col justify-end" data-testid={`sector-card-${i}`}>
                <img src={`/sectors/${IMAGES[i]}.jpg`} alt={item.t} loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#060A13]/95 via-[#060A13]/55 to-[#060A13]/15 transition-colors duration-500 group-hover:from-[#060A13]/95 group-hover:via-[#060A13]/65" />
                <div className="relative p-6">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-500 pl-2.5 pr-3 py-1.5 font-mono-tech text-[10px] font-bold uppercase tracking-wider text-[#04170F]" data-testid={`sector-badge-${i}`}>
                    <Icon size={13} weight="fill" />
                    {item.tag}
                  </span>
                  <h3 className="mt-4 font-display font-bold text-lg text-white">{item.t}</h3>
                  <p className="mt-2 text-[13px] leading-relaxed text-slate-200/90">{item.d}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
